import { musicGenres } from '../data/musicGenres';
import GenresGrid from '../components/GenresGrid';
import SectionHeader from '../components/SectionHeader';
import Footer from '../components/Footer';

const Genres = () => {

  document.title = "Genres";
  
  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20 ">
      <SectionHeader title="All Genres" />
      <GenresGrid collection={musicGenres} />
      <Footer />
    </div>
  );
};

export default Genres;